export default __webpack_public_path__ + "static/media/strafford.2727499f.png";